module.exports = __webpack_public_path__ + "fonts/fa-solid-900.ffc89d3e.ttf";